import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Router} from '@angular/router';
// import { StoreService }  from '../../shared/store/store.service';
import {DeviceService} from '../../shared/device/device.service';
// import { CognitoAuthService } from '../../shared/auth/cognito.service';
import * as _ from 'lodash';

declare const _;

@Component({
    selector: 'devices-table',
    templateUrl: './devices-table.component.html',
    styleUrls: ['./devices-table.component.css']
})
export class DevicesTableComponent implements OnChanges, OnInit {

    @Input() timePeriod: String = 'w';  // default value is 'week'
    @Input() deviceType: String = ''; // default value is null

    devices: any[ ] = [];

    isDevicesDataLoading = true;
    isDevicesDataError = false;

    sortByFields = [['type', 'last_seen'], ['risk', 'last_seen'], ['active', 'last_seen'], ['ip', 'last_seen'], ['name', 'last_seen'], ['mac', 'last_seen'], ['vendor', 'last_seen']];
    sortIndex = 0;
    sortAscending = false;

    status = ['fa-power-off text-danger', 'fa-exchange text-success'];

    // boolean to check if component was initialized
    // if not initialized, don't process changes
    initialized = false;

    _: any;

    constructor(private router: Router, private deviceService: DeviceService) {
        this._ = _;
    }

    // On initialization, retrieve devices based on @Input values
    ngOnInit() {
        // We don't need to do anything here since the ngOnChanges() get called before ngInit and retrieve the data for the system.
        // this.deviceService.getDeviceSummary({timePeriod: 'w', deviceType: ''}).subscribe(function(summary) {
        //     console.log(summary);
        // });
        this.getDevices(this.timePeriod, this.deviceType);
        this.initialized = true;
    }

    ngOnChanges(changes) {

        let updateNeeded = false;
        if ('deviceType' in changes) {
            if (typeof changes.deviceType !== undefined) {
                this.deviceType = changes.deviceType.currentValue;
                updateNeeded = true;
            }
        }
        if ('timePeriod' in changes) {
            if (typeof changes.timePeriod !== undefined) {
                this.timePeriod = changes.timePeriod.currentValue;
                updateNeeded = true;
            }
        }
        // call getDevices only if system is initialized
        if (this.initialized) {
            if (updateNeeded) {
                this.getDevices(this.timePeriod, this.deviceType);
            }
        }
    }

    // This is the main function invoked to retrieve the device list
    getDevices(timeFrame = this.timePeriod, type = this.deviceType) {

        const self = this;

        if (['h', 'd', 'w', 'm', 'q', 'y'].indexOf(timeFrame.toString()) == -1) {
            console.log('invalid timeFrame: ', timeFrame);
            return;
        }

        var param = {timePeriod: timeFrame, deviceType: type};

        self.deviceService.getDevices(param).subscribe(function (devices) {

            // map risk to risk categories for display as an icon
            devices.forEach(element => {
                element.riskLevel = Math.floor(element.risk/25);
            });

            if (self.deviceType != '') {
                self.devices = devices.filter(element => element.type == self.deviceType);
            } else {
                self.devices = devices;
            }

            self.isDevicesDataLoading = false;
            self.isDevicesDataError = false;

        }, function (err) {
            console.log('Error in getting device table. Called from devices-table.component.ts');
            console.log(err);
        });
    }

    // Sorting function for the table
    sortBy(i) {

        if (this.sortIndex === i) {
            this.sortAscending = !this.sortAscending;
        } else {
            this.sortAscending = false;
        }

        this.sortIndex = i;
        this.devices = _.sortBy(this.devices, this.sortByFields[i]);
        if (!this.sortAscending) {
            this.devices = _.reverse(this.devices);
        }
    }

    // Click event - navigate to the details page
    onSelectIp(deviceIP) {
        this.router.navigate(['/insight/', deviceIP]);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/devices-table/devices-table.component.ts